const value = {
    newPasswordTitle: 'Новый пароль',
    updatePasswordTitle: 'Смените пароль',
    newPasswordRequirementsBase:
      'Новый пароль должен быть надежным и отличаться от текущего. Убедитесь, что он содержит:',
    updatePasswordRequirementsBase_part_1:
      'Чтобы продолжить работу, придумайте новый пароль — это требование безопасности.',
    updatePasswordRequirementsBase_part_2:
      'Он должен быть надежным и отличаться от текущего. Убедитесь, что пароль содержит:',
    passwordRequirements1: '— не меньше 8 символов;',
    passwordRequirements2: '— заглавную и строчную букву;',
    passwordRequirements3: '— цифру;',
    passwordRequirements4: '— спецсимвол (например, !, @, #).',
    oldPassword: 'Текущий пароль',
    oldPasswordRequired: 'Введите текущий пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтверждение нового пароля',
    passwordsDoNotMatch: 'Пароль и подтверждение пароля не совпадают',
    passwordLengthError: 'Длина меньше {{min}} символов',
    oldPasswordIncorrect: 'Текущий пароль неверный',
    passwordComplexityError: 'Пароль должен содержать заглавные и строчные буквы, специальные символы, цифры',
    newAndOldPasswordSame: 'Текущий и новый пароль совпадают',
    directiveMissing: 'Смена пароля недоступна',
    save: 'Сохранить',
  };

export default value;
